import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Button } from "@chakra-ui/core";
import colors from "../utils/colors";
import { supportedColorValues } from "../utils/propTypes";

const SecondaryButton = forwardRef(
  ({ children, baseColor = colors.orchidBlue, ...rest }, ref) => {
    return (
      <Button
        type="submit"
        backgroundColor="transparent"
        color={baseColor}
        borderRadius="4px"
        border={`2px solid ${baseColor}`}
        height="auto"
        // Needed for some reason to override Chakra styles
        padding="18px 50px !important"
        textTransform="uppercase"
        letterSpacing="1.5px"
        fontSize="12px"
        _hover={{ backgroundColor: "orchidBlue40" }}
        cursor="pointer"
        fontWeight="500"
        {...rest}
      >
        {children}
      </Button>
    );
  }
);

SecondaryButton.displayName = "SecondaryButton";

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  baseColor: supportedColorValues,
};

export default SecondaryButton;
